import { ArrowLeftOutlined, WarningFilled } from '@ant-design/icons';
import {
  EnumRichiestaDTOStatoOneri,
  EnumUpdateStatoRichiestaRequestStato,
  RichiestaDTOStatoOneri,
  getGetFrontRichiesteIdQueryKey,
  usePutFrontRichiesteIdStato,
} from '@framework/api-client';
import { getNetworkErrorMessage } from '@framework/auth';
import { Trans, useTranslation } from '@framework/i18n';
import { ModalDialog } from '@framework/ui';
import { Button, Flex, Space, Typography, message } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { queryClient } from '../../../core/network/queryClient';

const { Text } = Typography;

export const BannerWrapper = styled.div`
  display: grid !important;
  grid-template-columns: 1fr 6fr 1fr;
  min-height: 30px;
  background-color: ${props => props.theme.colorWarningBg};
  padding: 12px;
`;
export const BannerIcon = styled.span`
  font-size: 24px;
  color: ${props => props.theme.colorTextBase};
`;
const WarningIcon = styled(WarningFilled)`
  color: ${props => props.theme.colorWarning};
`;

interface InPaymentBannerProps {
  submissionId: string;
  burdenStatus?: RichiestaDTOStatoOneri;
}

export function InPaymentBanner(props: InPaymentBannerProps) {
  const { submissionId, burdenStatus } = props;

  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = React.useState(false);
  const { mutate: updateSubmissionState, isLoading } =
    usePutFrontRichiesteIdStato({
      mutation: {
        onSuccess: response => {
          setModalOpen(false);
          const submissionQueryKey =
            getGetFrontRichiesteIdQueryKey(submissionId)[0];
          queryClient.invalidateQueries({
            predicate: ({ queryKey }) =>
              (queryKey[0] as string).includes(submissionQueryKey),
          });
        },
        onError: e => {
          message.error(
            getNetworkErrorMessage(
              e,
              t(
                'submission-payments.errore',
                `Si è verificato un errore durante la modifica dello stato della richiesta`,
              ),
            ),
          );
        },
      },
    });

  const handleConfirm = () => {
    updateSubmissionState({
      id: submissionId,
      data: { stato: EnumUpdateStatoRichiestaRequestStato.BOZZA },
    });
  };

  return (
    <>
      <BannerWrapper>
        <Button
          icon={<ArrowLeftOutlined />}
          ghost
          type="primary"
          onClick={() => setModalOpen(true)}
          loading={isLoading}
        >
          {t('submission-payments.riporta-in-bozza', 'Riporta in bozza')}
        </Button>

        <Flex align="center" justify="center" gap={12}>
          {/* <BannerIcon>
            <CalculatorOutlined aria-label="Informazione" />
          </BannerIcon> */}
          {burdenStatus === EnumRichiestaDTOStatoOneri.PAGATO ? (
            <Text strong>
              {t(
                'submission-payments.inviare-o-riportare-in-bozza',
                'La tua richiesta è stata pagata. È possibile inviarla, altrimenti è possibile riportarla in bozza per apportare modifiche, annullando i bolli pagati.',
              )}
            </Text>
          ) : (
            <Text strong>
              {t(
                'submission-payments.pagare-o-riportare-in-bozza',
                'La tua richiesta è in pagamento. Una volta pagati i bolli è possibile inviarla, altrimenti è possibile riportarla in bozza per apportare modifiche.',
              )}
            </Text>
          )}
        </Flex>
      </BannerWrapper>

      <ModalDialog
        open={modalOpen}
        title={
          <Space>
            <WarningIcon />
            {t(
              'submission-payments.annulla-pagamenti-e-torna-in-bozza',
              'Annulla pagamenti e ritorna in bozza',
            )}
          </Space>
        }
        onOk={handleConfirm}
        onCancel={() => setModalOpen(false)}
        width={600}
        destroyOnClose
      >
        <Space direction="vertical" style={{ width: '100%' }}>
          <Trans
            i18nKey="submission-payment.rieffettuare-il-pagamento-a-seguito-di-riportare-in-bozza"
            defaults="Riportando la richiesta in bozza, tutti <bold>i bolli pagati verranno invalidati</bold> e sarà necessario effettuare di nuovo il pagamento."
            components={{
              bold: <b />,
            }}
          />
          <span>
            {t(
              'submission-payment.conferma-a-procedere',
              'Si è sicuri di voler procedere?',
            )}
          </span>
        </Space>
      </ModalDialog>
    </>
  );
}
